import React, { useState, useEffect } from "react";
import { addHtmlElementClass, compareStrings, convertToDate, downloadServerPdf, getGradingNameFromGrade, is10Perfect, parseDateIsoFormat, parseGradeCentering, parseLabelType, parseLanguageAcronim, removeHtmlElementClass, selectNameByLanguage, titleize } from "../../utils/utils";
import LineChart from "./LineChart";
import GameNameParser from "./GameNameParser";
import EncasingParser from "./EncasingParser";
import I18n from 'i18n.js.erb'
import Modal from "react-bootstrap/Modal";
import IconTooltip from "./IconTooltip";
import GradingCertificatePopulation from "./GradingCertificatePopulation";
import DigitalCaseOverlay from "./DigitalCaseOverlay";

const RenderCertificate = ({ currentGrading, currentLabel, selectedRenderingType, changeSelectedRenderingType, frontGradedImage, backGradedImage, frontImage, backImage, blueprintImage, fakeData, data, chartData, isSingleCard, showCaseOverlay = false }) => {

    let isPristine = is10Perfect(currentGrading);

    // Sul fronte il gemello digitale c'e' per tutti i prodotti, case o sleeve che sia. Il retro invece
    // e' disegnato sul case della carta, con la sua etichetta posteriore: per i sigillati resta la foto
    const renderOverlay = showCaseOverlay
    const renderCase = showCaseOverlay && isSingleCard

    return (
        <React.Fragment>
            <div className='d-flex row mx-0 mt-1 pt-1dot5rem align-items-end'>
                <div className="col-7 col-sm-8 col-md-9 col-lg-9 col-xl-9 col-xxl-9-dot-5 col-xxxl-10 pl-md-3 pl-lg-5 pr-0">
                    <div className="border-bottom-light-gray">
                        <span className="certificate-page-title-label">{I18n.t('js.certificatePage.certificateOfGrading').toUpperCase()}</span>
                    </div>
                </div>
                <div className="col-5 col-sm-4 col-md-3 col-lg-3 col-xl-3 col-xxl-2-dot-5 col-xxxl-2 d-flex justify-content-start pl-0">
                    <img alt="" className="logo-aig-certificate-width" src={'/images/logo-AIGRADING-white.png'} />
                </div>
            </div>

            <div className="mt-xxl-3 min-h-vh-88 row d-flex align-items-center justify-content-around">
                <div className="d-none d-xxl-flex col-12 col-xxl-1 pl-xxxxxl-100px pl-20px mt-n3 justify-content-center">
                    <div className="extended-serial-number-div p-1">
                        <div className="extended-rotate-serial-number-div">
                            <span className="extended-serial-number">{currentGrading.extended_serial_number}</span>
                        </div>
                    </div>
                </div>
                <div className={`col-12 col-md-5 col-xl-4 col-xxl-3 col-xxxl-2-dot-5 col-xxxxxl-3 mt-5 mt-md-0 d-flex flex-column justify-content-center p-0 ${selectedRenderingType === 'raw' ? 'mt-n4' : ''}`}>
                    <div className="certificate-flip-card">
                        <div className="certificate-flip-card-inner">
                            <div className="justify-content-end justify-content-md-center certificate-flip-card-front d-flex align-items-center flex-column">
                                {renderOverlay ? (
                                    <DigitalCaseOverlay
                                        labelLines={[currentLabel.label_line_1, currentLabel.label_line_2, currentLabel.label_line_3, currentLabel.label_line_4, currentLabel.label_line_5]}
                                        titleLine={currentLabel.label_line_6}
                                        serialNumber={currentGrading.extended_serial_number}
                                        grading={currentGrading}
                                        evaluation={currentLabel.evaluation}
                                        size="xl"
                                        categoryName={blueprintImage.blueprint.category.name}
                                    >
                                        <img id="front_product_image" alt="" src={selectedRenderingType === 'raw' ? frontImage : frontGradedImage} className={`certificate-preview-grading-certificate-${isSingleCard ? 'single-card' : 'sealed'}-${selectedRenderingType}`} style={{ maxHeight: '350px', maxWidth: '300px', objectFit: 'contain' }} />
                                    </DigitalCaseOverlay>
                                ) : (
                                    <img id="front_product_image" alt="" src={selectedRenderingType === 'raw' ? frontImage : frontGradedImage} className={`certificate-preview-grading-certificate-${isSingleCard ? 'single-card' : 'sealed'}-${selectedRenderingType}`} height={isSingleCard ? 850 : 550} />
                                )}
                            </div>
                            <div className="d-flex certificate-flip-card-back align-items-center justify-content-end justify-content-md-center flex-column">
                                {renderCase &&
                                    <React.Fragment>
                                        <div className="bg-case-aig" />
                                        <div className={`certificate-back-fake-label${isPristine ? '-pristine' : ''} row`}>
                                            <div className={`label-line-container-back-upper ${isPristine ? 'd-none' : ''}`}>
                                                <div className={`${currentLabel.label_back_line_1 ? 'd-flex' : 'd-none'}`}>
                                                    <div className="label-line-back-text">{currentLabel.label_back_line_1?.split(' ')[0]}</div>
                                                    <div className="label-line-back-text-value">{currentLabel.label_back_line_1?.split(' ')[1]?.replace('.0', '')}</div>
                                                </div>
                                                <div className={`${currentLabel.label_back_line_2 ? 'd-flex' : 'd-none'}`}>
                                                    <div className="label-line-back-text">{currentLabel.label_back_line_2?.split(' ')[0]}</div>
                                                    <div className="label-line-back-text-value">{currentLabel.label_back_line_2?.split(' ')[1]?.replace('.0', '')}</div>
                                                </div>
                                                <div className={`${currentLabel.label_back_line_3 ? 'd-flex' : 'd-none'}`}>
                                                    <div className="label-line-back-text">{currentLabel.label_back_line_3?.split(' ')[0]}</div>
                                                    <div className="label-line-back-text-value">{currentLabel.label_back_line_3?.split(' ')[1]?.replace('.0', '')}</div>
                                                </div>
                                                <div className={`${currentLabel.label_back_line_4 ? 'd-flex' : 'd-none'}`}>
                                                    <div className="label-line-back-text">{currentLabel.label_back_line_4?.split(' ')[0]}</div>
                                                    <div className="label-line-back-text-value">{currentLabel.label_back_line_4?.split(' ')[1]?.replace('.0', '')}</div>
                                                </div>
                                                <div className={`${currentLabel.label_back_line_5 ? 'd-flex' : 'd-none'}`}>
                                                    <div className="label-line-back-text">{currentLabel.label_back_line_5?.split(' ')[0]}</div>
                                                    <div className="label-line-back-text-value">{currentLabel.label_back_line_5?.split(' ')[1]?.replace('.0', '')}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </React.Fragment>
                                }
                                <img id="back_product_image" alt="" src={selectedRenderingType === 'raw' ? backImage : backGradedImage} className={`certificate-preview-grading-certificate-${isSingleCard ? 'single-card' : 'sealed'}-${selectedRenderingType}`} height={isSingleCard ? 850 : 550} />
                            </div>
                        </div>
                    </div>
                    {frontGradedImage && backGradedImage && frontImage && backImage && (
                        <div className={`d-flex mt-4 align-content-center justify-content-center`}>
                            <div onClick={() => changeSelectedRenderingType('raw')} className="cursor-pointer">
                                <span className={`certificate-label-value-gray p-2 ${selectedRenderingType === 'raw' ? 'text-blue' : ''}`}>{I18n.t('js.certificatePage.raw')}</span>
                            </div>
                            <div onClick={() => changeSelectedRenderingType('encased')} className="cursor-pointer">
                                <span className={`certificate-label-value-gray p-2 ${selectedRenderingType === 'encased' ? 'text-blue' : ''}`}>{I18n.t('js.certificatePage.encased')}</span>
                            </div>
                        </div>
                    )}
                </div>
                <div className="col-12 col-md-7 col-xl-8 col-xxxl-8-dot-5 col-xxxxxl-8 mt-4 align-self-start p-0">
                    <div className="row pl-md-0 ml-md-0 pr-xl-5 px-2 mx-2 mt-4">
                        <div className={`col-6 col-md-4 col-xl-3 certificate-border-bottom certificate-border-right`}>
                            <div className="my-1">
                                <span className={`certificate-label-title text--truncate`}> {I18n.t('js.certificatePage.serialNumber').toUpperCase()}&nbsp;</span>
                            </div>
                            <div className="mb-1">
                                <span className={`certificate-label-value-no-padding`}>{currentGrading.extended_serial_number}</span>
                            </div>
                        </div>
                        <div className="col-6 col-md-4 col-xl-3 certificate-border-md-right certificate-border-bottom">
                            <div className="my-1">
                                <span className={`certificate-label-title`}>{I18n.t('js.certificatePage.encasing').toUpperCase()} &nbsp;</span>
                            </div>
                            <div className="mb-1">
                                <span className={`certificate-label-value-no-padding`}>
                                    <EncasingParser
                                        encasing={currentGrading.encasing}
                                        categoryName={blueprintImage.blueprint.category.name}
                                    /></span>
                            </div>
                        </div>
                        <div className="col-6 col-md-4 col-xl-3 certificate-border-right certificate-border-bottom">
                            <div className="my-1">
                                <span className={`certificate-label-title`}>{I18n.t('js.certificatePage.labelType').toUpperCase()}</span>
                            </div>
                            <div className="mb-1">
                                <span className={`certificate-label-value-no-padding`}>{parseLabelType(currentGrading.label_type)}</span>
                            </div>
                        </div>
                        <div className={`col-6 col-md-4 col-xl-3 certificate-border-md-right border-right-xl-none certificate-border-bottom`}>
                            <div className="my-1">
                                <span className={`certificate-label-title`}>{I18n.t('js.certificatePage.labelLanguage').toUpperCase()}&nbsp;</span>
                            </div>
                            <div className="mb-1">
                                <span className={`certificate-label-value-no-padding`}>
                                    {parseLanguageAcronim(currentGrading?.label_language)}
                                </span>
                            </div>
                        </div>

                        <div className={`col-6 col-md-4 col-xl-3 certificate-border-bottom certificate-border-right`}>
                            <div className="my-1">
                                <span className={`certificate-label-title`}>{I18n.t('js.certificatePage.itemName').toUpperCase()}</span>
                            </div>
                            <div className="mb-1 text--truncate">
                                <span className={`certificate-label-value-no-padding`}>
                                    {selectNameByLanguage(currentGrading.label_language, blueprintImage.meta_name, blueprintImage.en_name)}
                                </span>
                            </div>
                        </div>
                        <div className="col-6 col-md-4 col-xl-3 certificate-border-md-right certificate-border-bottom">
                            <div className="my-1">
                                <span className={`certificate-label-title`}>{I18n.t('js.cardInfoPage.game').toUpperCase()}&nbsp;</span>
                            </div>
                            <div className="mb-1">
                                <span className={`certificate-label-value-no-padding`}><GameNameParser game_name={blueprintImage.game.name} /></span>
                            </div>
                        </div>
                        <div className={`col-6 col-md-4 col-xl-3 certificate-border-bottom certificate-border-right`}>
                            <div className="my-1">
                                <span className={`certificate-label-title`}>{I18n.t('js.cardInfoPage.era').toUpperCase()}&nbsp;</span>
                            </div>
                            <div className="mb-1 text-truncate">
                                <span className={`certificate-label-value-no-padding`}>
                                    {selectNameByLanguage(currentGrading.label_language, blueprintImage.era_name, blueprintImage.en_era_name)}
                                </span>
                            </div>
                        </div>
                        <div className={`col-6 col-md-4 col-xl-3 certificate-border-md-right border-right-xl-none certificate-border-bottom`}>
                            <div className="my-1">
                                <span className={`certificate-label-title`}>{I18n.t('js.cardInfoPage.expansion').toUpperCase()}</span>
                            </div>
                            <div className="mb-1">
                                <div className="text--truncate">
                                    <span className={`certificate-label-value-no-padding`}>
                                        {selectNameByLanguage(currentGrading.label_language, blueprintImage.expansion_name, blueprintImage.en_expansion_name)}
                                    </span>
                                </div>
                            </div>
                        </div>

                        <div className="col-6 col-md-4 col-xl-3 border-bottom-xl-none certificate-border-right certificate-border-bottom">
                            <div className="my-1">
                                <span className={`certificate-label-title`}> {I18n.t('js.certificatePage.itemNumber').toUpperCase()}&nbsp;</span>
                            </div>
                            <div className="mb-1">
                                <span className={`certificate-label-value-no-padding`}>{blueprintImage.collector_number || '-'}</span>
                            </div>
                        </div>
                        <div className="col-6 col-md-4 col-xl-3 certificate-border-bottom border-bottom-md-none certificate-border-md-right">
                            <div className="my-1">
                                <span className={`certificate-label-title`}>{I18n.t('js.cardInfoPage.version').toUpperCase()}&nbsp;</span>
                            </div>
                            <div className="mb-1 text-truncate">
                                <span className={`certificate-label-value-no-padding`}>{titleize(blueprintImage.version) || '-'}</span>
                            </div>
                        </div>
                        <div className={`col-6 col-md-4 col-xl-3 certificate-border-right`}>
                            <div className="my-1">
                                <span className={`certificate-label-title`}>{I18n.t('js.cardInfoPage.rarity').toUpperCase()}&nbsp;</span>
                            </div>
                            <div className="mb-1">
                                <div className="text--truncate">
                                    <span className={`certificate-label-value-no-padding`}>{titleize(blueprintImage.rarity) || '-'}</span>
                                </div>
                            </div>
                        </div>
                        <div className={`col-6 col-md-4 col-xl-3`}>
                            <div className="my-1">
                                <span className={`certificate-label-title`}> {I18n.t('js.cardInfoPage.release').toUpperCase()}&nbsp;</span>
                            </div>
                            <div className="mb-1">
                                <span className={`certificate-label-value-no-padding`}>{blueprintImage.released_at ? parseDateIsoFormat(convertToDate(blueprintImage.released_at), '%d/%m/%Y') : '-'}</span>
                            </div>
                        </div>
                    </div>

                    <div className="pr-xl-5">
                        <div className="min-h-vh-xl-65 row d-flex justify-content-center align-items-center mx-0">
                            <div className="col-12 col-xl-6 col-xxxl-6 col-xxxxl-6 px-4 px-md-0 certificate-line-chart-container">
                                {data.values.every(value => value === null) ?
                                    <React.Fragment>
                                        <div className="no-data-available-div">
                                            <span className="no-data-available-text">{I18n.t('js.certificatePage.noDataAvailable').toUpperCase()}</span>
                                        </div>
                                        <div className="empty-certificate-data h-100">
                                            <LineChart
                                                type={'polarArea'}
                                                datasets={fakeData.datasets}
                                                labels={fakeData.labels}
                                                options={fakeData.options}
                                                id={currentGrading.extended_serial_number}
                                            />
                                        </div>
                                    </React.Fragment>
                                    :
                                    <LineChart
                                        type={'polarArea'}
                                        datasets={data.datasets}
                                        labels={data.labels}
                                        options={data.options}
                                        id={currentGrading.extended_serial_number}
                                    />
                                }
                            </div>
                            <div className="d-none d-xl-flex col-12 col-xl-6 col-xxxl-6 col-xxxxl-6 align-self-end flex-column px-0">
                                <div className='py-2 w-100'>
                                    {/* <GradeOverallHeader overallWithEvaluation={`${currentGrading.grade_overall ? `${currentGrading.grade_overall} - ` : ''}${isDefined(currentGrading.evaluations[1]) ? currentGrading.evaluations[1] : isDefined(getGradingNameFromGrade(currentGrading.grade_overall?.toString(), currentGrading.is_10_perfect)[1]) ? getGradingNameFromGrade(currentGrading.grade_overall?.toString(), currentGrading.is_10_perfect)[1] : 'Authentic'}`} /> */}
                                    {isSingleCard ? (
                                        <SingleCardGradingData currentGrading={currentGrading} chartData={chartData} />
                                    ) : (
                                        <SealedGradingData currentGrading={currentGrading} chartData={chartData} />
                                    )}
                                </div>
                                <div className="d-flex justify-content-center">
                                    <div className="mt-xl-5 mb-xl-5 row w-100">
                                        <CertificateFooter emittedDate={currentGrading.emitted_at?.split('-')[0]} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="d-xl-none mt-4 col-12">
                    <div className="px-md-4 w-100">
                        {/* <GradeOverallHeader overallWithEvaluation={`${currentGrading.grade_overall} - ${isDefined(currentGrading.evaluations[1]) ? currentGrading.evaluations[1] : isDefined(getGradingNameFromGrade(currentGrading.grade_overall?.toString(), currentGrading.is_10_perfect)[1]) ? getGradingNameFromGrade(currentGrading.grade_overall?.toString(), currentGrading.is_10_perfect)[1] : 'Authentic'}`} /> */}
                        {isSingleCard ? (
                            <SingleCardGradingData currentGrading={currentGrading} chartData={chartData} />
                        ) : (
                            <SealedGradingData currentGrading={currentGrading} chartData={chartData} />
                        )}
                        <div className="d-flex justify-content-center">
                            <div className="row my-5 w-100 text-center">
                                <CertificateFooter emittedDate={currentGrading.emitted_at?.split('-')[0]} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}

const GradeOverallHeader = ({
    overallWithEvaluation
}) => {
    return (
        <div className="my-2">
            <div className="col-12 w-100 px-0">
                <div className="d-flex w-100 flex-column pl-3">
                    <span className={`certificate-label-grade-overall d-block text--white-space-no-wrap`}>{I18n.t('js.certificatePage.gradeOverall').toUpperCase()}</span>
                    <span className={`certificate-label-value-grade-overall text--white-space-no-wrap`}>{overallWithEvaluation}</span>
                </div>
            </div>
            <div className="border-bottom-light-gray3 w-100 mr-2 align-self-center mt-3"></div>
        </div>
    )
}

const SingleCardGradingData = ({
    currentGrading,
    chartData
}) => {

    // Funzione per ottenere il colore corretto per una label
    const getColorForLabel = (label) => {
        const index = chartData.labels.indexOf(label.toUpperCase());
        if (index === -1) return 'rgba(0, 0, 0, 0.3)';
        return chartData.colors[index % chartData.colors.length];
    }

    return (
        <div>
            <div className="row sealed-grading-data-grid mx-0">
                <div className={`col-6 col-sm-4 py-xxxxl-3 py-2`}>
                    <div className="text--truncate">
                        <span className={`certificate-label-title-abbreviation`} style={{ color: getColorForLabel(I18n.t('js.certificatePage.surfaceOverallAbbreviation')) }}>{I18n.t('js.certificatePage.surfaceOverallAbbreviation').toUpperCase()}</span>
                        <span className={`certificate-label-title pl-xxxxl-2 pl-1`}>{I18n.t('js.certificatePage.surfaceOverall').toUpperCase()}</span>
                    </div>
                    <div>
                        <span className={`certificate-label-value-no-padding`}>{currentGrading.grade_surface_overall || '-'}</span>
                    </div>
                </div>
                <div className={`col-6 col-sm-4 py-xxxxl-3 py-2`}>
                    <div className="text--truncate">
                        <span className={`certificate-label-title-abbreviation`} style={{ color: getColorForLabel(I18n.t('js.certificatePage.surfaceFrontAbbreviation')) }}>{I18n.t('js.certificatePage.surfaceFrontAbbreviation').toUpperCase()}</span>
                        <span className={`certificate-label-title pl-xxxxl-2 pl-1`}>{I18n.t('js.certificatePage.surfaceFront').toUpperCase()}</span>
                    </div>
                    <div>
                        <span className={`certificate-label-value-no-padding`}>{currentGrading.grade_surface_front || '-'}</span>
                    </div>
                </div>
                <div className={`col-6 col-sm-4 py-xxxxl-3 py-2`}>
                    <div className="text--truncate">
                        <span className={`certificate-label-title-abbreviation`} style={{ color: getColorForLabel(I18n.t('js.certificatePage.surfaceBackAbbreviation')) }}>{I18n.t('js.certificatePage.surfaceBackAbbreviation').toUpperCase()}</span>
                        <span className={`certificate-label-title pl-xxxxl-2 pl-1`}>{I18n.t('js.certificatePage.surfaceBack').toUpperCase()}</span>
                    </div>
                    <div>
                        <span className={`certificate-label-value-no-padding`}>{currentGrading.grade_surface_back || '-'}</span>
                    </div>
                </div>
                <div className={`col-6 col-sm-4 py-xxxxl-3 py-2`}>
                    <div className="text--truncate">
                        <span className={`certificate-label-title-abbreviation`} style={{ color: getColorForLabel(I18n.t('js.certificatePage.edgesOverallAbbreviation')) }}>{I18n.t('js.certificatePage.edgesOverallAbbreviation').toUpperCase()}</span>
                        <span className={`certificate-label-title pl-xxxxl-2 pl-1`}>{I18n.t('js.certificatePage.edgesOverall').toUpperCase()}</span>
                    </div>
                    <div>
                        <span className={`certificate-label-value-no-padding`}>{currentGrading.grade_edges_overall || '-'}</span>
                    </div>
                </div>
                <div className={`col-6 col-sm-4 py-xxxxl-3 py-2`}>
                    <div className="text--truncate">
                        <span className={`certificate-label-title-abbreviation`} style={{ color: getColorForLabel(I18n.t('js.certificatePage.edgesFrontAbbreviation')) }}>{I18n.t('js.certificatePage.edgesFrontAbbreviation').toUpperCase()}</span>
                        <span className={`certificate-label-title pl-xxxxl-2 pl-1`}>{I18n.t('js.certificatePage.edgesFront').toUpperCase()}</span>
                    </div>
                    <div>
                        <span className={`certificate-label-value-no-padding`}>{currentGrading.grade_edges_front || '-'}</span>
                    </div>
                </div>
                <div className={`col-6 col-sm-4 py-xxxxl-3 py-2`}>
                    <div className="text--truncate">
                        <span className={`certificate-label-title-abbreviation`} style={{ color: getColorForLabel(I18n.t('js.certificatePage.edgesBackAbbreviation')) }}>{I18n.t('js.certificatePage.edgesBackAbbreviation').toUpperCase()}</span>
                        <span className={`certificate-label-title pl-xxxxl-2 pl-1`}>{I18n.t('js.certificatePage.edgesBack').toUpperCase()}</span>
                    </div>
                    <div>
                        <span className={`certificate-label-value-no-padding`}>{currentGrading.grade_edges_back || '-'}</span>
                    </div>
                </div>
                <div className={`col-6 col-sm-4 py-xxxxl-3 py-2`}>
                    {currentGrading.grade_corners ?
                        <React.Fragment>
                            <div className="text--truncate mb-1 ">
                                <span className={`certificate-label-title`}>{I18n.t('js.certificatePage.corners').toUpperCase()}</span>
                            </div>
                            <div className="text--truncate mb-1">
                                <span className={`certificate-label-value-no-padding`}>{currentGrading.grade_corners === 'geometric' ? I18n.t('js.productInfoPage.gradeCornersCompliant') : I18n.t('js.productInfoPage.gradeCornersNotCompliant')}</span>
                            </div>
                        </React.Fragment>
                        :
                        <React.Fragment>
                            <div className="text--truncate">
                                <span className={`certificate-label-title-abbreviation`} style={{ color: getColorForLabel(I18n.t('js.certificatePage.cornersOverallAbbreviation')) }}>{I18n.t('js.certificatePage.cornersOverallAbbreviation').toUpperCase()}</span>
                                <span className={`certificate-label-title pl-xxxxl-2 pl-1`}>{I18n.t('js.certificatePage.cornersOverall').toUpperCase()}</span>
                            </div>
                            <div>
                                <span className={`certificate-label-value-no-padding`}>{currentGrading.grade_corners_overall || '-'}</span>
                            </div>
                        </React.Fragment>
                    }
                </div>
                <div className={`col-6 col-sm-4 py-xxxxl-3 py-2`}>
                    <div className="text--truncate">
                        <span className={`certificate-label-title-abbreviation`} style={{ color: getColorForLabel(I18n.t('js.certificatePage.cornersFrontAbbreviation')) }}>{I18n.t('js.certificatePage.cornersFrontAbbreviation').toUpperCase()}</span>
                        <span className={`certificate-label-title pl-xxxxl-2 pl-1`}>{I18n.t('js.certificatePage.cornersFront').toUpperCase()}</span>
                    </div>
                    <div>
                        <span className={`certificate-label-value-no-padding`}>{currentGrading.grade_corners_front || '-'}</span>
                    </div>
                </div>
                <div className={`col-6 col-sm-4 py-xxxxl-3 py-2`}>
                    <div className="text--truncate">
                        <span className={`certificate-label-title-abbreviation`} style={{ color: getColorForLabel(I18n.t('js.certificatePage.cornersBackAbbreviation')) }}>{I18n.t('js.certificatePage.cornersBackAbbreviation').toUpperCase()}</span>
                        <span className={`certificate-label-title pl-xxxxl-2 pl-1`}>{I18n.t('js.certificatePage.cornersBack').toUpperCase()}</span>
                    </div>
                    <div>
                        <span className={`certificate-label-value-no-padding`}>{currentGrading.grade_corners_back || '-'}</span>
                    </div>
                </div>
                <div className={`col-6 col-sm-4 py-xxxxl-3 py-2`}>
                    <div className="text--truncate">
                        <span className={`certificate-label-title-abbreviation`} style={{ color: getColorForLabel(I18n.t('js.certificatePage.centeringFrontAbbreviation')) }}>{I18n.t('js.certificatePage.centeringFrontAbbreviation').toUpperCase()}</span>
                        <span className={`certificate-label-title pl-xxxxl-2 pl-1`}>{I18n.t('js.certificatePage.centeringFront').toUpperCase()}</span>
                    </div>
                    <div>
                        <span className={`certificate-label-value-no-padding`}>{currentGrading.grade_centering_front || '-'}</span>
                    </div>
                </div>
                <div className={`col-6 col-sm-4 py-xxxxl-3 py-2`}>
                    <div className="text--truncate">
                        <span className={`certificate-label-title`}>{I18n.t('js.certificatePage.centeringFrontHorz').toUpperCase()}</span>
                    </div>
                    <div>
                        <span className={`certificate-label-value-no-padding`}>
                            {currentGrading.grade_centering_front_left_right ?
                                parseGradeCentering(currentGrading.grade_centering_front_left_right)
                                : '-'
                            }
                        </span>
                    </div>
                </div>
                <div className={`col-6 col-sm-4 py-xxxxl-3 py-2`}>
                    <div className="text--truncate">
                        <span className={`certificate-label-title`}>{I18n.t('js.certificatePage.centeringFrontVert').toUpperCase()}</span>
                    </div>
                    <div>
                        <span className={`certificate-label-value-no-padding`}>
                            {currentGrading.grade_centering_front_top_bottom ?
                                parseGradeCentering(currentGrading.grade_centering_front_top_bottom)
                                : '-'
                            }
                        </span>
                    </div>
                </div>
                <div className={`col-6 col-sm-4 py-xxxxl-3 py-2`}>
                    <div className="text--truncate">
                        <span className={`certificate-label-title-abbreviation`} style={{ color: getColorForLabel(I18n.t('js.certificatePage.centeringBackAbbreviation')) }}>{I18n.t('js.certificatePage.centeringBackAbbreviation').toUpperCase()}</span>
                        <span className={`certificate-label-title pl-xxxxl-2 pl-1`}>{I18n.t('js.certificatePage.centeringBack').toUpperCase() || '-'}</span>
                    </div>
                    <div>
                        <span className={`certificate-label-value-no-padding`}>{currentGrading.grade_centering_back || '-'}</span>
                    </div>
                </div>
                <div className={`col-6 col-sm-4 py-xxxxl-3 py-2`}>
                    <div className="text--truncate">
                        <span className={`certificate-label-title`}>{I18n.t('js.certificatePage.centeringBackHorz').toUpperCase() || '-'}</span>
                    </div>
                    <div>
                        <span className={`certificate-label-value-no-padding`}>
                            {currentGrading.grade_centering_back_left_right ?
                                parseGradeCentering(currentGrading.grade_centering_back_left_right)
                                : '-'
                            }
                        </span>
                    </div>
                </div>
                <div className={`col-6 col-sm-4 py-xxxxl-3 py-2`}>
                    <div className="text--truncate">
                        <span className={`certificate-label-title`}>{I18n.t('js.certificatePage.centeringBackVert').toUpperCase()}</span>
                    </div>
                    <div>
                        <span className={`certificate-label-value-no-padding`}>
                            {currentGrading.grade_centering_back_top_bottom ?
                                parseGradeCentering(currentGrading.grade_centering_back_top_bottom)
                                : '-'
                            }
                        </span>
                    </div>
                </div>
            </div>
        </div>
    )
}

const SealedGradingData = ({
    currentGrading,
    chartData
}) => {

    // Funzione per ottenere il colore corretto per una label
    const getColorForLabel = (label) => {
        const index = chartData.labels.indexOf(label.toUpperCase());
        if (index === -1) return 'rgba(0, 0, 0, 0.3)';
        return chartData.colors[index % chartData.colors.length];
    }

    return (
        <div>
            <div className="row sealed-grading-data-grid">
                <div className="col-6 col-sm-4">
                    <div className="text--truncate">
                        <span className={`certificate-label-title-abbreviation`} style={{ color: getColorForLabel(I18n.t('js.certificatePage.surfaceOverallAbbreviation')) }}>{I18n.t('js.certificatePage.surfaceOverallAbbreviation').toUpperCase()}</span>
                        <span className={`certificate-label-title pl-xxxxl-2 pl-1`}>{I18n.t('js.certificatePage.surfaceOverall').toUpperCase()}</span>
                    </div>
                    <div className="mb-1">
                        <span className={`certificate-label-value-no-padding pl-4`}>{currentGrading.grade_sealed_surface || '-'}</span>
                    </div>
                </div>

                <div className="col-6 col-sm-4">
                    <div className="text--truncate">
                        <span className={`certificate-label-title-abbreviation`} style={{ color: getColorForLabel(I18n.t('js.certificatePage.surfaceFrontAbbreviation')) }}>{I18n.t('js.certificatePage.surfaceFrontAbbreviation').toUpperCase()}</span>
                        <span className={`certificate-label-title pl-xxxxl-2 pl-1`}>{I18n.t('js.certificatePage.surfaceFront').toUpperCase()}</span>
                    </div>
                    <div className="mb-1">
                        <span className={`certificate-label-value-no-padding pl-4`}>{currentGrading.grade_sealed_surface_front || '-'}</span>
                    </div>
                </div>

                <div className="col-6 col-sm-4">
                    <div className="text--truncate">
                        <span className={`certificate-label-title-abbreviation`} style={{ color: getColorForLabel(I18n.t('js.certificatePage.surfaceBackAbbreviation')) }}>{I18n.t('js.certificatePage.surfaceBackAbbreviation').toUpperCase()}</span>
                        <span className={`certificate-label-title pl-xxxxl-2 pl-1`}>{I18n.t('js.certificatePage.surfaceBack').toUpperCase()}</span>
                    </div>
                    <div className="mb-1">
                        <span className={`certificate-label-value-no-padding pl-4`}>{currentGrading.grade_sealed_surface_back || '-'}</span>
                    </div>
                </div>

                <div className="col-6 col-sm-4">
                    <div className="text--truncate">
                        <span className={`certificate-label-title-abbreviation`} style={{ color: getColorForLabel(I18n.t('js.certificatePage.sealingAbbreviation')) }}>{I18n.t('js.certificatePage.sealingAbbreviation').toUpperCase()}</span>
                        <span className={`certificate-label-title pl-xxxxl-2 pl-1`}>{I18n.t('js.certificatePage.sealing').toUpperCase()}</span>
                    </div>
                    <div className="mb-1">
                        <span className={`certificate-label-value-no-padding pl-4`}>{currentGrading.grade_sealing || '-'}</span>
                    </div>
                </div>

                <div className="col-6 col-sm-4">
                    <div className="text--truncate">
                        <span className={`certificate-label-title-abbreviation`} style={{ color: getColorForLabel(I18n.t('js.certificatePage.sealingFrontAbbreviation')) }}>{I18n.t('js.certificatePage.sealingFrontAbbreviation').toUpperCase()}</span>
                        <span className={`certificate-label-title pl-xxxxl-2 pl-1`}>{I18n.t('js.certificatePage.sealingFront').toUpperCase()}</span>
                    </div>
                    <div className="mb-1">
                        <span className={`certificate-label-value-no-padding pl-4`}>{currentGrading.grade_sealing_front || '-'}</span>
                    </div>
                </div>

                <div className="col-6 col-sm-4">
                    <div className="text--truncate">
                        <span className={`certificate-label-title-abbreviation`} style={{ color: getColorForLabel(I18n.t('js.certificatePage.sealingBackAbbreviation')) }}>{I18n.t('js.certificatePage.sealingBackAbbreviation').toUpperCase()}</span>
                        <span className={`certificate-label-title pl-xxxxl-2 pl-1`}>{I18n.t('js.certificatePage.sealingBack').toUpperCase()}</span>
                    </div>
                    <div className="mb-1">
                        <span className={`certificate-label-value-no-padding pl-4`}>{currentGrading.grade_sealing_back || '-'}</span>
                    </div>
                </div>

                <div className="col-6 col-sm-4">
                    <div className="text--truncate">
                        <span className={`certificate-label-title-abbreviation`} style={{ color: getColorForLabel(I18n.t('js.certificatePage.sealedCornersAbbreviation')) }}>{I18n.t('js.certificatePage.sealedCornersAbbreviation').toUpperCase()}</span>
                        <span className={`certificate-label-title pl-xxxxl-2 pl-1`}>{I18n.t('js.certificatePage.sealedCorners').toUpperCase()}</span>
                    </div>
                    <div className="mb-1">
                        <span className={`certificate-label-value-no-padding pl-4`}>{currentGrading.grade_sealed_corners || '-'}</span>
                    </div>
                </div>

                <div className="col-6 col-sm-4">
                    <div className="text--truncate">
                        <span className={`certificate-label-title-abbreviation`} style={{ color: getColorForLabel(I18n.t('js.certificatePage.sealedCornersFrontAbbreviation')) }}>{I18n.t('js.certificatePage.sealedCornersFrontAbbreviation').toUpperCase()}</span>
                        <span className={`certificate-label-title pl-xxxxl-2 pl-1`}>{I18n.t('js.certificatePage.sealedCornersFront').toUpperCase()}</span>
                    </div>
                    <div className="mb-1">
                        <span className={`certificate-label-value-no-padding pl-4`}>{currentGrading.grade_sealed_corners_front || '-'}</span>
                    </div>
                </div>

                <div className="col-6 col-sm-4">
                    <div className="text--truncate">
                        <span className={`certificate-label-title-abbreviation`} style={{ color: getColorForLabel(I18n.t('js.certificatePage.sealedCornersBackAbbreviation')) }}>{I18n.t('js.certificatePage.sealedCornersBackAbbreviation').toUpperCase()}</span>
                        <span className={`certificate-label-title pl-xxxxl-2 pl-1`}>{I18n.t('js.certificatePage.sealedCornersBack').toUpperCase()}</span>
                    </div>
                    <div className="mb-1">
                        <span className={`certificate-label-value-no-padding pl-4`}>{currentGrading.grade_sealed_corners_front || '-'}</span>
                    </div>
                </div>

                <div className="col-6 col-sm-4">
                    <div className="text--truncate">
                        <span className={`certificate-label-title`}>{I18n.t('js.certificatePage.hangingHole')}</span>
                    </div>
                    <div className="mb-1">
                        <span className={`certificate-label-value-no-padding`}>
                            {currentGrading.grade_hanging_hole ?
                                currentGrading.grade_hanging_hole === 'opened' ? I18n.t('js.productInfoPage.hangingHoleOpened') : I18n.t('js.productInfoPage.hangingHoleIntact')
                                : '-'
                            }
                        </span>
                    </div>
                </div>

                <div className="col-6 col-sm-4">
                    <div className="text--truncate">
                        <span className={`certificate-label-title`}>{I18n.t('js.certificatePage.materialCondition')}</span>
                    </div>
                    <div className="mb-1">
                        <span className={`certificate-label-value-no-padding`}>
                            {currentGrading.grade_material_condition ?
                                currentGrading.grade_material_condition === 'damaged' ? I18n.t('js.productInfoPage.materialConditionDamaged') : I18n.t('js.productInfoPage.materialConditionNotDamaged')
                                : '-'}
                        </span>
                    </div>
                </div>


                <div className="col-6 col-sm-4">
                    <div className="text--truncate">
                        <span className={`certificate-label-title`}>{I18n.t('js.certificatePage.contentCompliance')}</span>
                    </div>
                    <div className="mb-1">
                        <span className={`certificate-label-value-no-padding`}>
                            {currentGrading.grade_content_compliance ?
                                currentGrading.grade_content_compliance === 'compliant' ? I18n.t('js.productInfoPage.gradeContentCompliant') : I18n.t('js.productInfoPage.gradeContentNotCompliant')
                                : '-'}
                        </span>
                    </div>
                </div>

                <div className="col-6 col-sm-4">
                    <div className="text--truncate">
                        <span className={`certificate-label-title`}>{I18n.t('js.certificatePage.flatness').toUpperCase()}</span>
                    </div>
                    <div className="mb-1">
                        <span className={`certificate-label-value-no-padding`}>
                            {currentGrading.grade_flatness ?
                                currentGrading.grade_flatness === 'flat' ? I18n.t('js.productInfoPage.flat') : I18n.t('js.productInfoPage.notFlat')
                                : '-'}
                        </span>
                    </div>
                </div>

                <div className="col-6 col-sm-4">
                    <div className="text--truncate">
                        <span className={`certificate-label-title`}>{I18n.t('js.certificatePage.crimping').toUpperCase()}</span>
                    </div>
                    <div className="mb-1">
                        <span className={`certificate-label-value-no-padding`}>
                            {currentGrading.grade_crimping ?
                                currentGrading.grade_crimping === 'regular' ? I18n.t('js.productInfoPage.regular') : I18n.t('js.productInfoPage.notRegular')
                                : '-'}
                        </span>
                    </div>
                </div>

                <div className="col-6 col-sm-4">
                    <div className="text--truncate">
                        <span className={`certificate-label-title`}>{I18n.t('js.productInfoPage.extraInfo').toUpperCase()}</span>
                    </div>
                    <div className="mb-1">
                        <span className={`certificate-label-value-no-padding`}>
                            {(currentGrading.heavy_light && currentGrading.extra_info) ?
                                (currentGrading.extra_info + ' - ' + titleize(currentGrading.heavy_light))
                                :
                                currentGrading.heavy_light ?
                                    (titleize(currentGrading.heavy_light))
                                    :
                                    currentGrading.extra_info ?
                                        (currentGrading.extra_info)
                                        :
                                        '-'
                            }
                        </span>
                    </div>
                </div>
            </div>
        </div>
    )
}

const CertificateFooter = ({
    emittedDate
}) => {
    return (
        <div className="d-flex justify-content-around w-100 mt-2">
            <div className="d-flex flex-column">
                <span className={`certificate-label-title-footer d-block`}>{I18n.t('js.certificatePage.certificateIssuedOn').toUpperCase()}</span>
                <span className={`certificate-label-value-no-padding text-center`}>{emittedDate || '-'}</span>
            </div>
            <div className="d-flex flex-column">
                <span className={`certificate-label-title-footer d-block`}>{I18n.t('js.certificatePage.gradingTeamLeader').toUpperCase()}</span>
                <img src="/images/signature_team_leader.svg" width={'184'} height={'84'} className="mt-n4" />
            </div>
        </div>
    )
}

const initializeGradingStatsCharts = (currentGrading, isSingleCard = true) => {

    let chartData = {
        labels: isSingleCard ? [
            I18n.t('js.certificatePage.surfaceFrontAbbreviation'),
            I18n.t('js.certificatePage.surfaceBackAbbreviation'),
            I18n.t('js.certificatePage.edgesFrontAbbreviation'),
            I18n.t('js.certificatePage.edgesBackAbbreviation'),
            I18n.t('js.certificatePage.centeringFrontAbbreviation'),
            I18n.t('js.certificatePage.centeringBackAbbreviation')
        ] : [
            I18n.t('js.certificatePage.sealingAbbreviation'),
            I18n.t('js.certificatePage.sealedSurfaceAbbreviation'),
        ],
        tooltipLabels: isSingleCard ? [
            I18n.t('js.certificatePage.surfaceFront'),
            I18n.t('js.certificatePage.surfaceBack'),
            I18n.t('js.certificatePage.edgesFront'),
            I18n.t('js.certificatePage.edgesBack'),
            I18n.t('js.certificatePage.centeringFront'),
            I18n.t('js.certificatePage.centeringBack')
        ] : [
            I18n.t('js.certificatePage.sealing'),
            I18n.t('js.certificatePage.sealedSurface')
        ],
        colors: isSingleCard ? [
            'rgba(133, 160, 255, 0.7)',
            'rgba(51, 122, 227, 0.7)',
            'rgba(63, 186, 255, 0.7)',
            'rgba(255, 190, 23, 0.7)',
            'rgba(215, 114, 27, 0.7)',
            'rgba(235, 85, 85, 0.7)'
        ] : [
            'rgba(133, 160, 255, 0.7)',
            'rgba(255, 190, 23, 0.7)',
            'rgba(51, 122, 227, 0.7)',
            'rgba(63, 186, 255, 0.7)',
            'rgba(215, 114, 27, 0.7)',
            'rgba(235, 85, 85, 0.7)',
            'rgba(141, 208, 82, 0.7)',
            'rgba(110, 163, 63, 0.7)',
            'rgba(86, 129, 49, 0.7)',
        ],
        values: isSingleCard ? [
            currentGrading.grade_surface_front,
            currentGrading.grade_surface_back,
            currentGrading.grade_edges_front,
            currentGrading.grade_edges_back,
            currentGrading.grade_centering_front || null,
            currentGrading.grade_centering_back || null
        ] : [
            currentGrading.grade_sealing,
            currentGrading.grade_sealed_surface
        ]
    }


    if (currentGrading.grade_surface_overall) {
        chartData.labels.push(I18n.t('js.certificatePage.surfaceOverallAbbreviation'));
        chartData.tooltipLabels.push(I18n.t('js.certificatePage.surfaceOverall'));
        chartData.values.push(currentGrading.grade_surface_overall);
        chartData.colors.push('rgba(141, 208, 82, 0.7)');
    }

    if (currentGrading.grade_edges_overall) {
        chartData.labels.push(I18n.t('js.certificatePage.edgesOverallAbbreviation'));
        chartData.tooltipLabels.push(I18n.t('js.certificatePage.edgesOverall'));
        chartData.values.push(currentGrading.grade_edges_overall);
        chartData.colors.push('rgba(110, 163, 63, 0.7)');
    }

    if (currentGrading.grade_corners_overall) {
        chartData.labels.push(I18n.t('js.certificatePage.cornersOverallAbbreviation'));
        chartData.tooltipLabels.push(I18n.t('js.certificatePage.cornersOverall'));
        chartData.values.push(currentGrading.grade_corners_overall);
        chartData.colors.push('rgba(86, 129, 49, 0.7)');
    }

    if (currentGrading.grade_corners_front) {
        chartData.labels.push(I18n.t('js.certificatePage.cornersFrontAbbreviation'));
        chartData.tooltipLabels.push(I18n.t('js.certificatePage.cornersFront'));
        chartData.values.push(currentGrading.grade_corners_front);
        chartData.colors.push('rgba(253, 125, 255, 0.7)');
    }

    if (currentGrading.grade_corners_back) {
        chartData.labels.push(I18n.t('js.certificatePage.cornersBackAbbreviation'));
        chartData.tooltipLabels.push(I18n.t('js.certificatePage.cornersBack'));
        chartData.values.push(currentGrading.grade_corners_back);
        chartData.colors.push('rgba(179, 48, 255, 0.7)');
    }

    if (currentGrading.grade_sealed_corners) {
        chartData.labels.push(I18n.t('js.certificatePage.sealedCorners'));
        chartData.tooltipLabels.push(I18n.t('js.certificatePage.sealedCorners'));
        chartData.values.push(currentGrading.grade_sealed_corners);
    }

    const fakeLabels = [
        I18n.t('js.certificatePage.surfaceOverall'),
        I18n.t('js.certificatePage.surfaceFront'),
        I18n.t('js.certificatePage.surfaceBack'),
        I18n.t('js.certificatePage.edgesOverall'),
        I18n.t('js.certificatePage.edgesFront'),
        I18n.t('js.certificatePage.edgesBack'),
        I18n.t('js.certificatePage.cornersOverall'),
        I18n.t('js.certificatePage.cornersFront'),
        I18n.t('js.certificatePage.cornersBack'),
        I18n.t('js.certificatePage.centeringFront'),
        I18n.t('js.certificatePage.centeringBack')
    ]

    const fakeValues = [
        8, 6, 9.5, 4.5, 9, 7.5, 8, 6, 9.5, 9, 7.5
    ]

    const data = {
        labels: chartData.labels,
        datasets: [{
            data: chartData.values,
            backgroundColor: chartData.colors,
            borderColor: 'rgba(255, 255, 255, 1)',
            borderWidth: 5
        }],
        values: chartData.values,
        options: {
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
                datalabels: {
                    labels: {
                        value: {
                            color: (context) => { return chartData.colors[context.dataIndex] },
                            font: {
                                weight: 'medium',
                                size: window.innerWidth > 1920 ? 1 : 10,
                                style: 'normal',
                                family: "Jost",
                            }
                        }
                    },
                    anchor: 'end',
                    align: 'end',
                    display: 'auto',
                    rotation: 0,
                    clamp: true,
                    clip: false,
                    textAlign: 'center',
                    formatter: function (value, context) {
                        return chartData.labels[context.dataIndex]?.replace(' ', '\n');
                    }
                },
                tooltip: {
                    enabled: true,
                    callbacks: {
                        title: function (context) {
                            return chartData.tooltipLabels[context[0].dataIndex]
                        }
                    }
                },
                legend: {
                    display: false
                }
            },
            layout: {
                padding: 40
            },
            scales: {
                r: {
                    pointLabels: {
                        display: false,
                        centerPointLabels: true
                    },
                    angleLines: {
                        display: false
                    },
                    grid: {
                        display: true
                    },
                    ticks: {
                        stepSize: 2,
                        display: false
                    },
                    min: 0,
                    max: 10
                }
            }
        }
    };

    //Utilizzo Fake Data per renderizzare un grafico con dati completamente fasulli in caso la carta non abbia dati (esempio authentic)
    const fakeData = {
        labels: fakeLabels,
        datasets: [{
            data: fakeValues,
            backgroundColor:
                ['rgba(133, 160, 255, 0.7)',
                    'rgba(51, 122, 227, 0.7)',
                    'rgba(63, 186, 255, 0.7)',
                    'rgba(255, 190, 23, 0.7)',
                    'rgba(215, 114, 27, 0.7)',
                    'rgba(235, 85, 85, 0.7)',
                    'rgba(141, 208, 82, 0.7)',
                    'rgba(110, 163, 63, 0.7)',
                    'rgba(86, 129, 49, 0.7)',
                    'rgba(253, 125, 255, 0.7)',
                    'rgba(179, 48, 255, 0.7)'],
            borderColor: 'rgba(255, 255, 255, 1)',
            borderWidth: 4
        }],
        options: {
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
                datalabels: {
                    display: false,
                },
                tooltip: {
                    enabled: false
                },
                legend: {
                    display: false
                }
            },
            layout: {
                padding: 40
            },
            scales: {
                r: {
                    pointLabels: {
                        display: false,
                        centerPointLabels: true
                    },
                    angleLines: {
                        display: false
                    },
                    grid: {
                        display: true
                    },
                    ticks: {
                        stepSize: 2,
                        display: false
                    },
                    min: 0,
                    max: 10
                }
            }
        }
    };

    return [chartData, data, fakeData]
}

const GradingCertificate = ({ originalGradingCertificate, originalLabel, originalBlueprintImage, showCertificate, setShowCertificate = null, showAsModal = true, showCaseOverlay = false }) => {

    const [frontImage, setFrontImage] = useState(null);
    const [backImage, setBackImage] = useState(null);
    const [frontGradedImage, setFrontGradedImage] = useState(null);
    const [backGradedImage, setBackGradedImage] = useState(null);
    const [population, setPopulation] = useState(null);
    const [selectedRenderingType, setSelectedRenderingType] = useState('raw')
    const [loaded, setLoaded] = useState(null)
    const [controlNotch, setControlNotch] = useState(false)
    let currentGrading = null;
    let currentLabel = null;
    let blueprintImage = null;
    let data = null;
    let fakeData = null;
    let isSingleCard = null;
    let certificateNotchTimer = null;
    let certificateNotchTimerFadingOut = null;
    let chevronBottomTimer = null;
    let chevronBottomTimerFadingOut = null;
    let chevronTopTimer = null;
    let chevronTopTimerFadingOut = null;
    let chartData = {}

    if (originalGradingCertificate && originalBlueprintImage) {

        blueprintImage = originalBlueprintImage
        currentGrading = originalGradingCertificate
        currentLabel = originalLabel

        isSingleCard = compareStrings(blueprintImage.blueprint.category.name, 'singles');

        [chartData, data, fakeData] = initializeGradingStatsCharts(currentGrading, isSingleCard)
    }

    useEffect(() => {
        if (showCertificate ) {
            if (currentGrading.xx_large_image_url && currentGrading.xx_large_back_image_url &&
                currentGrading.xx_large_graded_image_url && currentGrading.xx_large_graded_back_image_url){
                setFrontGradedImage(currentGrading.xx_large_graded_image_url);
                setBackGradedImage(currentGrading.xx_large_graded_back_image_url);
                setFrontImage(currentGrading.xx_large_image_url)
                setBackImage(currentGrading.xx_large_back_image_url)
                setSelectedRenderingType('encased');
                setLoaded(true)
            }
            else if (currentGrading.xx_large_image_url && currentGrading.xx_large_back_image_url){
                setFrontImage(currentGrading.xx_large_image_url)
                setBackImage(currentGrading.xx_large_back_image_url)
                setSelectedRenderingType('raw');
                setLoaded(true)
            }
            else if (currentGrading.serial_number) {
                // Only try to load images from server if not a preview
                loadImages(selectedRenderingType);
            } else {
                setLoaded(true);
            }
        } else {
            $('html, body').css('overflowY', '');
            setFrontGradedImage(null);
            setBackGradedImage(null);
            setFrontImage(null);
            setBackImage(null);
            setPopulation(null);
            setLoaded(null);
            setControlNotch(null);
        }
    }, [showCertificate]);

    const showCertificateNotch = () => {
        clearTimeout(certificateNotchTimer);
        clearTimeout(certificateNotchTimerFadingOut);
        if (controlNotch) {
            removeHtmlElementClass(document, 'certificate-notch', 'd-none');
            certificateNotchTimer = setTimeout(() => {
                certificateNotchTimerFadingOut = setTimeout(() => {
                    addHtmlElementClass(document, 'certificate-notch', 'd-none');
                }, 500)
            }, 1500);
        }
    }

    const showBottomChevron = () => {
        const scrollableElement = document.querySelector('.scrollable');
        if (!scrollableElement) return;
        const isAtTop = scrollableElement.scrollTop < 10;

        if (isAtTop && population) {
            clearTimeout(chevronBottomTimer);
            clearTimeout(chevronBottomTimerFadingOut);
            removeHtmlElementClass(document, 'certificate-bottom-chevron', 'fade-out-bottom-chevron');
            removeHtmlElementClass(document, 'certificate-bottom-chevron', 'd-none');
            addHtmlElementClass(document, 'certificate-bottom-chevron', 'fade-in-bottom-chevron');
            chevronBottomTimer = setTimeout(() => {
                removeHtmlElementClass(document, 'certificate-bottom-chevron', 'fade-in-bottom-chevron');
                addHtmlElementClass(document, 'certificate-bottom-chevron', 'fade-out-bottom-chevron');
                chevronBottomTimerFadingOut = setTimeout(() => {
                    addHtmlElementClass(document, 'certificate-bottom-chevron', 'd-none');
                }, 500)
            }, 1500);
        }
    }

    const showTopChevron = () => {
        const scrollableElement = document.querySelector('.scrollable');
        if (!scrollableElement) return;

        const isAtBottom = scrollableElement.scrollTop + scrollableElement.clientHeight >= scrollableElement.scrollHeight - 10;

        if (isAtBottom) {
            clearTimeout(chevronTopTimer);
            clearTimeout(chevronTopTimerFadingOut);
            removeHtmlElementClass(document, 'certificate-top-chevron', 'fade-out-bottom-chevron');
            removeHtmlElementClass(document, 'certificate-top-chevron', 'd-none');
            addHtmlElementClass(document, 'certificate-top-chevron', 'fade-in-bottom-chevron');
            chevronTopTimer = setTimeout(() => {
                removeHtmlElementClass(document, 'certificate-top-chevron', 'fade-in-bottom-chevron');
                addHtmlElementClass(document, 'certificate-top-chevron', 'fade-out-bottom-chevron');
                chevronTopTimerFadingOut = setTimeout(() => {
                    addHtmlElementClass(document, 'certificate-top-chevron', 'd-none');
                }, 500)
            }, 1500);
        }
    }

    const showPopulation = () => {
        const populationSection = document.querySelector("#population-render")
        populationSection.scrollIntoView({ behavior: "smooth" })
    }

    const backToCertificate = () => {
        const certificateSection = document.querySelector("#certificate-render")
        certificateSection.scrollIntoView({ behavior: "smooth" })
    }

    // Funzione che chiede al server le immagini del prodotto gradato da renderizzare sul certificato
    const loadImages = () => {
        if (originalGradingCertificate && currentGrading) {
            let url = '/grading_certificate/' + currentGrading?.serial_number;
            if (url) {
                fetch(url + ".json", {
                    method: 'GET'
                })
                    .then(response => response.json())
                    .then((data) => {

                        // Controllo se il proprietario del prodotto sia lo stesso che sta navigando la pagina web 
                        if (data.user?.id == data.current_grading?.user_id) {
                            setControlNotch(true)
                        }

                        // set graded front image and graded back image
                        if (data.current_grading.xx_large_graded_image_url && data.current_grading.xx_large_graded_back_image_url) {
                            setFrontGradedImage(data.current_grading.xx_large_graded_image_url);
                            setBackGradedImage(data.current_grading.xx_large_graded_back_image_url);
                            setSelectedRenderingType('encased')
                        }

                        // set front image and back image
                        if (data.current_grading.xx_large_image_url && data.current_grading.xx_large_back_image_url) {
                            setFrontImage(data.current_grading.xx_large_image_url);
                            setBackImage(data.current_grading.xx_large_back_image_url);
                            setSelectedRenderingType('raw')
                        }

                        // set population
                        if (data.grading_population) {
                            setPopulation(data.grading_population)
                        }

                        $('html, body').css('overflowY', 'hidden');

                        setLoaded(true)
                    })
                    .catch((error) => {
                        console.error("ERROR:", error);
                    });
            }
        }
    };

    const saveImages = () => {
        function fetchImageAsBlob(imgElement) {
            return fetch(imgElement.src, { method: "GET" })
                .then(response => response.blob())
                .then(blob => URL.createObjectURL(blob))
                .catch(error => { console.error("Errore nel recupero dell'immagine:", error); return null; });
        }

        // Scarica direttamente il blob dell'immagine sorgente, bypassando html2canvas.
        // html2canvas falliva sul back image a causa del flip card (backface-visibility
        // + rotateY) producendo un PNG da 0 byte. Il blob della src restituisce il file
        // originale in qualità sorgente, senza re-encoding.
        function captureAndDownload(imgElement, fileName) {
            fetchImageAsBlob(imgElement).then(objectURL => {
                if (!objectURL) return;
                const link = document.createElement("a");
                link.download = fileName;
                link.href = objectURL;
                link.click();
                URL.revokeObjectURL(objectURL);
            });
        }

        const frontImageElement = document.getElementById("front_product_image");
        if (frontImageElement) {
            captureAndDownload(frontImageElement, currentGrading.extended_serial_number + "_front.png");
        }

        const backImageElement = document.getElementById("back_product_image");
        if (backImageElement) {
            captureAndDownload(backImageElement, currentGrading.extended_serial_number + "_back.png");
        }
    }

    const sendMail = () => {
        window.open(
            `mailto:?subject=${encodeURIComponent(I18n.t('js.certificatePage.notch.sendMail.subject')
                .replace(':serial_number', currentGrading.extended_serial_number))}
                &body=${encodeURIComponent(I18n.t('js.certificatePage.notch.sendMail.body')
                    .replace(':serial_number', currentGrading.extended_serial_number)
                    .replace(':link', `${window.location.origin}/grading_certificate/${currentGrading.serial_number}`))}
                    %0D%0A%0D%0APowered by AiGrading.com`
        );
    }

    // Il PDF del certificato lo genera il server, con l'immagine (prodotto nudo o nella custodia) scelta sulla pagina
    const downloadCertificate = () => {
        downloadServerPdf(`/grading_certificate/${currentGrading.serial_number}.pdf?rendering_type=${selectedRenderingType}`)
            .catch((error) => console.error("ERROR:", error));
    }

    const Certificate = ({ }) => {
        return(
            <React.Fragment>
                <div id="certificate-render" className="min-h-vh-100">
                    {(loaded) ?
                        <React.Fragment>
                            {showAsModal && 
                                <div className="position-absolute w-100 p-2">
                                    <div id="certificate-close-button" className="d-flex justify-content-end" >
                                        <IconTooltip
                                            tooltipPosition={'bottom'}
                                            tooltipIcon={'fas fa-comment'}
                                            tooltipTitle={''}
                                            tooltipContent={I18n.t('js.common.button.close')}
                                            additionalClassesForIcon={'black'}
                                            customComponentToRender={
                                                <img src={window.location.origin + '/images/icons/blue/close.svg'}
                                                    width="18px"
                                                    className="cursor-pointer"
                                                    onClick={() =>
                                                        setShowCertificate ? setShowCertificate(false)
                                                            :
                                                            window.location.href = window.location.origin
                                                    }
                                                />
                                            }
                                        />
                                    </div>
                                    <div id="certificate-notch" className="certificate-notch-margins d-none" style={{ top: 0 }}>
                                        <div className="d-flex justify-content-center">
                                            <div className="certificate-notch-bg bg-aig-gradient d-flex justify-content-around align-items-center">
                                                <div className="mx-3">
                                                    <IconTooltip
                                                        tooltipPosition={'bottom'}
                                                        tooltipIcon={'fas fa-comment'}
                                                        tooltipTitle={''}
                                                        tooltipContent={I18n.t('js.certificatePage.notch.download')}
                                                        customComponentToRender={
                                                            <img src={window.location.origin + '/images/icons/white/download_certificate_images.svg'}
                                                                width="14px"
                                                                className="cursor-pointer"
                                                                onClick={saveImages}
                                                            />
                                                        }
                                                    />
                                                </div>
                                                <div className="mx-3">
                                                    <IconTooltip
                                                        tooltipPosition={'bottom'}
                                                        tooltipIcon={'fas fa-comment'}
                                                        tooltipTitle={''}
                                                        tooltipContent={I18n.t('js.certificatePage.notch.sendMail.tooltip')}
                                                        additionalClassesForIcon={'black'}
                                                        customComponentToRender={
                                                            <img src={window.location.origin + '/images/icons/white/send_by_mail_empty.svg'}
                                                                width="24px"
                                                                className="cursor-pointer"
                                                                onClick={sendMail}
                                                            />
                                                        }
                                                    />
                                                </div>
                                                <div className="mx-3">
                                                    <IconTooltip
                                                        tooltipPosition={'bottom'}
                                                        tooltipIcon={'fas fa-comment'}
                                                        tooltipTitle={''}
                                                        tooltipContent={I18n.t('js.certificatePage.notch.downloadCertificate')}
                                                        additionalClassesForIcon={'black'}
                                                        customComponentToRender={
                                                            <img src={window.location.origin + '/images/icons/white/download-certificate-white.svg'}
                                                                width="24px"
                                                                className={`cursor-pointer`}
                                                                onClick={downloadCertificate}
                                                            />
                                                        }
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                            <div id="certificate-render">
                                <RenderCertificate
                                    currentGrading={currentGrading}
                                    currentLabel={currentLabel}
                                    selectedRenderingType={selectedRenderingType}
                                    changeSelectedRenderingType={setSelectedRenderingType}
                                    frontGradedImage={frontGradedImage}
                                    backGradedImage={backGradedImage}
                                    frontImage={frontImage}
                                    backImage={backImage}
                                    blueprintImage={blueprintImage}
                                    fakeData={fakeData}
                                    data={data}
                                    chartData={chartData}
                                    isSingleCard={isSingleCard}
                                    showCaseOverlay={showCaseOverlay}
                                />
                            </div>
                            <div className="position-absolute w-100 d-none d-xl-block mt-n5">
                                <div id="certificate-bottom-chevron" className="d-none mb-5 certificate-bottom-chevron-flex text-center">
                                    <div className="certificate-bottom-chevron-content flex-column" onClick={() => showPopulation()}>
                                        <span className="certificate-label-title">{I18n.t('js.certificatePage.population')}</span>
                                        <IconTooltip
                                            tooltipPosition={'top'}
                                            tooltipIcon={'fas fa-comment'}
                                            tooltipTitle={''}
                                            tooltipContent={I18n.t('js.certificatePage.checkPopulation')}
                                            additionalClassesForIcon={'black'}
                                            customComponentToRender={
                                                <img src={window.location.origin + '/images/icons/blue/arrow-down.svg'} width="40px" className="cursor-pointer" />
                                            }
                                        />
                                    </div>
                                </div>

                            </div>
                        </React.Fragment>
                        :
                        <React.Fragment>
                            <div className="d-flex justify-content-center flex-column align-items-center min-h-vh-100">
                                <div>
                                    <div className="gradient-spinner d-flex justify-content-center align-items-center" role="status" style={{ width: '160px', height: '160px' }} />
                                </div>
                                <div className="d-flex flex-column justify-content-center align-items-center" style={{ position: 'absolute' }}>
                                    <img src={window.location.origin + '/images/Icona-AIGRADING-Favicon.svg'} width="24px" className="cursor-pointer" />
                                    <span className="certificate-loading-serial-number mt-1">{currentGrading.extended_serial_number || 'B000000000'}</span>
                                </div>
                            </div>
                        </React.Fragment>
                    }
                </div>

                {(population && loaded) &&
                    <React.Fragment>
                        <div id="population-render" className="w-100 bg-white min-h-vh-100" onMouseMove={showTopChevron}>
                            <div className={`position-absolute w-100 text-center d-none d-xl-block mt-2`}>
                                <div id="certificate-top-chevron" className="d-none certificate-top-chevron-flex justify-content-center position-absolute w-100 z-index-99 mt-4 flex-column" onClick={() => backToCertificate()}>
                                    <IconTooltip
                                        tooltipPosition={'bottom'}
                                        tooltipIcon={'fas fa-comment'}
                                        tooltipTitle={''}
                                        tooltipContent={I18n.t('js.certificatePage.checkCertificate')}
                                        additionalClassesForIcon={'black'}
                                        customComponentToRender={
                                            <img src={window.location.origin + '/images/icons/blue/arrow-up.svg'} width="40px" className="cursor-pointer" />
                                        }
                                    />
                                    <span className="certificate-label-title">{I18n.t('js.certificatePage.certificate')}</span>
                                </div>
                            </div>

                            <GradingCertificatePopulation
                                blueprintImage={blueprintImage}
                                currentGrading={currentGrading}
                                gradedCardsCount={population.gradedProductsCount}
                                gradingsByScore={population.gradingsByScore}
                                gradingsByEncasing={population.gradingsByEncasing}
                                gradedProductsByEncasingCount={population.gradedProductsByEncasingCount}
                                gradedBeforeCount={population.gradedBeforeCount}
                                gradedAfterCount={population.gradedAfterCount}
                                frontImage={frontImage}
                                backImage={backImage}
                            />
                        </div>
                    </React.Fragment>
                }
            </React.Fragment>
        )
    }

    return (
        originalGradingCertificate && currentGrading &&
        <React.Fragment>
            {showAsModal ? 
                <Modal
                    id="view-certificate-modal"
                    className="scrollable"
                    show={showCertificate}
                    onHide={() => setShowCertificate ? setShowCertificate(false) : nil}
                    animation={false}
                    dialogClassName="modal-100perc"
                    onMouseMove={() => {
                        showBottomChevron();
                        showCertificateNotch();
                    }}
                >
                    <Certificate/>
                </Modal>
            :
                <Certificate/>
            }
        </React.Fragment>
    )
}
export default GradingCertificate;
export { RenderCertificate };